import axiosInstance from "../axiosInstance";

const BASE_URL = "/settings/signature-assets";

export const getSignatureAssets = async (params = {}) => {
  const response = await axiosInstance.get(BASE_URL, { params });
  return response.data;
};

export const uploadSignatureAsset = async (formData) => {
  const response = await axiosInstance.post(BASE_URL, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const activateSignatureAsset = async (id) => {
  const response = await axiosInstance.patch(`${BASE_URL}/${id}/activate`);
  return response.data;
};

export const deleteSignatureAsset = async (id) => {
  const response = await axiosInstance.delete(`${BASE_URL}/${id}`);
  return response.data;
};

export const getSignatureAssetImageUrl = (id) => {
  const base = axiosInstance.defaults.baseURL || "";
  return `${base}${BASE_URL}/${id}/image`;
};
